import { Container } from "./MetricsAndReports.styles";

export const AgreementConversionsFunnel = () => {
  return (
    <Container>
      <iframe
        src="https://milestone.cloud.looker.com/embed/public/looks/KDP5J5Q8xkc7w4xtgSZDd88hNpthJWtp"
        height="100%"
        width="100%"
        style={{ border: "none" }}
      />
    </Container>
  );
};
